export default __webpack_public_path__ + "static/media/sv22_en_alph_a2.1b687eb6.mp3";